import { render, staticRenderFns } from "./WidgetFooterView.vue?vue&type=template&id=6b3e2ac1&"
import script from "./WidgetFooterView.vue?vue&type=script&lang=js&"
export * from "./WidgetFooterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports